export const useMicApplyStore = defineStore({
  id: 'micApply',
  state: () => ({
    /** 排麦人数 */
    micApplyTotal: 0 as number,
    /** 排麦反馈类型  0:无，1：同意，2：拒绝*/
    micApplyCallbackType: 0 as 0 | 1 | 2
  }),
  actions: {
    /** 设置排麦反馈类型 */
    setMicApplyCallbackType(type: 0 | 1 | 2) {
      this.micApplyCallbackType = type
    },
    /** 排麦回调 */
    onMultiRoomMicApply(data) {
      this.micApplyTotal = data.custom.data.total
    },
    /** 排麦取消回调 */
    onMultiRoomMicCancel(data) {
      this.micApplyTotal = data.custom.data.total
    },
    /** 排麦同意-管理会收到 */
    onMultiRoomMicAgree(data) {
      if (data) {
        this.setMicApplyCallbackType(1)
        const total = this.micApplyTotal - 1
        this.micApplyTotal = total < 0 ? 0 : total
      }
    },
    /** 排麦拒绝 */
    onMultiRoomMicReject(data) {
      if (data) {
        this.setMicApplyCallbackType(2)
        const total = this.micApplyTotal - 1
        this.micApplyTotal = total < 0 ? 0 : total
      }
    },
    // 重置数据
    resetData() {
      this.micApplyTotal = 0
      this.setMicApplyCallbackType(0)
    }
  }
})
